import { render, staticRenderFns } from "./kv-phone-input.vue?vue&type=template&id=507ef918&scoped=true"
import script from "./kv-phone-input.vue?vue&type=script&lang=js"
export * from "./kv-phone-input.vue?vue&type=script&lang=js"
import style0 from "./kv-phone-input.vue?vue&type=style&index=0&id=507ef918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507ef918",
  null
  
)

export default component.exports